import '../../vite-env.d'; // Import our environment variable type definitions
import { AIProviderType } from './types';

export interface AIConfig {
  provider: AIProviderType;
  apiKey: string;
  model: string;
  temperature: number;
  maxTokens: number;
  assistantId?: string;
}

// Default config uses API key from environment
export const defaultConfig: AIConfig = {
  provider: 'openai',
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  model: 'gpt-4',
  temperature: 0.3, 
  maxTokens: 6000
};